import { defineComponent as _defineComponent } from 'vue';
import {} from "@/api";
import { withPrefix } from "@/utils/redirect";
import { bytesToString } from "@/utils/utils";
import DatasetHashes from "@/components/DatasetInformation/DatasetHashes.vue";
import DatasetSources from "@/components/DatasetInformation/DatasetSources.vue";
import DecodedId from "@/components/DecodedId.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetInformation',
    props: {
        dataset: null
    },
    setup(__props) {
        return { __sfc: true, withPrefix, bytesToString, DatasetHashes, DatasetSources, DecodedId, UtcDate };
    }
});
